//版本v1.1
import request from '@/utils/request'
//模拟链式request
export function requestRoot(url_parms,data) {
    //如果API有这个参数，转发到真实请求上
    if(url_parms!=undefined && url_parms.hasOwnProperty('request')){
      return request(url_parms);
    }
   
    let TempFun = new function(){};
    TempFun.data=data;
    //模拟成功返回数据
    TempFun.then = function(callback,error){
     let response = [];// eval("data['"+url_parms.url+"']"); //eval(data[url_parms.url]);// eval("data"+url_parms.url); 
     let method = url_parms.url.substring(url_parms.url.lastIndexOf("/")+1,url_parms.url.length); 
     if(this.data.hasOwnProperty(method)) {
         response = this.data[method];
     }
     //console.log(response);
     //模拟函数操作返回
     if(typeof response == "function") response = eval(response(url_parms.params||url_parms.data));//函数时执行函数
     //模拟网络类错误
     if(url_parms!=undefined && url_parms.hasOwnProperty('testNetErr')  &&  url_parms.testNetErr== 1){
       return TempFun;
     }else{
       //模拟服务器业务返回错误
       if(url_parms!=undefined && url_parms.hasOwnProperty('testErr')  &&  url_parms.testErr== 1){
         if(error!=undefined) error({msg:"业务出错了！"});
       }else{//模拟服务业务成功返回
         if(callback!=undefined) callback(response);
       }
     }
     return TempFun;
  }
  //模拟网络类错误
  TempFun.catch = function(error){
   if(url_parms!=undefined && url_parms.hasOwnProperty('testNetErr')  &&  url_parms.testNetErr== 1){
     if(error!=undefined) error({msg:"Error: 网络出错了！"});
   }
   return TempFun;
  }
  //调用层返回函数对象；
  return TempFun;
  }


//单字段单值筛选, 如输入list,"name","Leila" 期望输出为 [{name:'Leila', age: 16, gender:'female'}]
export function Listfilter_1Value(list,name,value) {
  return list.filter(item => item[name] == value)
}

export function Listfilter_1Value_not(list,name,value) {
  return list.filter(item => item[name] != value)
}

//单字段多值筛选，如输入list,"name",['Anne','Jay'],期望输出为 [{name:'Anne', age: 23, gender:'female'},{name:'Jay', age: 19, gender:'male'}]
export function Listfilter_nValue(list,name,values) {
  let result = []
  for(let i = 0; i < values.length; i++) {
    let obj = list.filter(item => item[name] == values[i]);
    console.log(obj);
    //if(obj!=undefined ) result.push(obj);
    if(obj.length > 0){
      for(let j = 0; j < obj.length; j++){
        result.push(obj[j]);
      }
    }
    
  }
  return result
}

//单字段多值筛选，如输入list,"name",['Anne','Jay'],期望输出为 [{name:'Anne', age: 23, gender:'female'},{name:'Jay', age: 19, gender:'male'}]
export function Listfilter_nValue_Not(list,name,values) {
  let result = []
  list.forEach(item => {
    let flag = false;
    for(let i = 0; i < values.length; i++) {
      item[name] == values[i];
      flag = true;
    }
    if(!flag) result.push(item);
  });
  return result
}

export function Listfilter_nValueList(list,name,values,valueName) {
  let result = []
  list.forEach(item => {
    let flag = false;
    //!flag 在这里实现break的作用
    for(let i = 0; !flag && i < values.length; i++) {
      if(item[name] == values[i][valueName]) flag = true;
    }
    if(flag) result.push(item);
  });
  return result
}

export function Listfilter_nValueList_Not(list,name,values,valueName) {
  let result = []
  list.forEach(item => {
    let flag = false;
    //!flag 在这里实现break的作用
    for(let i = 0; !flag && i < values.length; i++) {
      if(item[name] == values[i][valueName]) flag = true;
    }
    if(!flag) result.push(item);
  });
  return result
}


//双字段单值或筛选,如输入list,"name","Anne" ,"age","19" 期望输出为 [{name:'Anne', age: 23, gender:'female'},{name:'Jay', age: 19, gender:'male'}]
export function Listfilter_2Condi_Or(list, name1, value1, name2, value2) {
  return list.filter(item => item[name1] == value1 || item[name2] == value2)
}

export function Listfilter_2Condi_Or_Not(list, name1, value1, name2, value2) {
  return list.filter(item => item[name1] != value1 && item[name2] != value2)
}

//双字段单值与筛选,如输入list,"name","Anne" ,"age","23" 期望输出为 [{name:'Anne', age: 23, gender:'female'}]
export function Listfilter_2Condi_And(list, name1, value1, name2, value2) {
  return list.filter(item => item[name1] == value1 && item[name2] == value2)
}

export function Listfilter_2Condi_And_Not(list, name1, value1, name2, value2) {
  return list.filter(item => item[name1] != value1 || item[name2] != value2)
}

//根据名字和年龄多元素筛选,如list,{name:['Leila', 'Jay'],age:[]},[{name: "Leila", age: 16, gender: "female"},{name: "Jay", age: 19, gender: "male"}]
export function Listfilter_nCondi_And(list, filters) {
  const filterKeys = Object.keys(filters)
  // filters all elements passing the criteria
  return list.filter((item) => {
    // dynamically validate all filter criteria
    return filterKeys.every(key => {
        //ignore when the filter is empty Anne
      if(!filters[key].length) return true
      return !!~filters[key].indexOf(item[key])
    })
  })
}


// WEBPACK FOOTER //
// ./src/api/aRequestRoot.js